<div class="d-flex h-100" [attr.id]="divId" [ngStyle]="{'background-color': background_color.color,'color': text_color.color, 'border-radius': borderRadius, 'border': border}" [ngClass]="[alignmentClass,textBlockAlignmentClass]"  [appStoryblok]="_editable">
  <div class="col-12 py-2">
    <app-page [content]="text.content"></app-page>
  </div>
